import React, { useState, useEffect } from 'react';
import DataTable from 'react-data-table-component';

import { useContext } from 'components/Admin/Webinars/Context';

import Filters from './Table/Filters';
import columns from './Table/columns';
import data from './Table/data';

export default function Table() {
  const { dispatch, actions, state } = useContext();
  const [keyword, setKeyword] = useState('');

  useEffect(() => {
    actions.load(dispatch);
  }, []);

  return (
    <>
      <Filters keyword={keyword} setKeyword={setKeyword} />

      <div className="datatable-style">
        <DataTable
          title=""
          columns={columns}
          data={data(state.webinars, keyword) || []}
          noDataComponent={(
            <div className="mt20">
              {state.webinars == null
                ? 'Please, wait ...'
                : 'No matching records found'}
            </div>
          )}
          persistTableHead
          pagination
          paginationComponentOptions={{
            selectAllRowsItem: true,
            selectAllRowsItemText: 'All',
          }}
        />
      </div>
    </>
  );
}
